/** @format */
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { BasicAlert } from 'src/components/Alert'

const ImportantSentence = (fileName, setKeyText) => {
  const readJsonFile = async (fileName, setKeyText) => {
    const jsonFileName = fileName.replace('.txt', '.json')
    const msg = require(`public/law-summary/summary/${jsonFileName}`)

    if (msg && msg.keytext) {
      setKeyText(msg.keytext)
    } else {
      setKeyText(['중요 문장 추출이 되지 않았습니다. (기능 수정 중)'])
    }
  }
  readJsonFile(fileName, setKeyText)
}

const ProjectContentHeader = ({ fileName, getNextFile, getPrevFile, OpenLawFile, setKeyText }) => {
  return (
    <div className='aiso_detail_header grid grid-cols-2 item-center gap-3 p-3 lg:gap-6 w-full lg:flex lg:justify-end lg:whitespace-pre-line lg:break-all'>
      <button
        type='text'
        className='btn-whitePrimary px-3 py-2 tracking-tight font-bold text-sm lg:text-base'
        onClick={() => {
          ImportantSentence(fileName, setKeyText)
        }}
      >
        중요 문장 표시
      </button>
      <button
        type='text'
        className='btn-whitePrimary px-3 py-2 tracking-tight font-bold text-sm lg:text-base'
        onClick={() => BasicAlert('문서 요약 기능 구현 중입니다.')}
      >
        문서 요약
      </button>

      <button
        type='text'
        className='btn-whitePrimary px-3 py-2 tracking-tight font-bold text-sm lg:text-base'
        onClick={() => {
          setKeyText([''])
          OpenLawFile(getPrevFile(fileName))
        }}
      >
        <FontAwesomeIcon icon={faChevronLeft} className='mr-2 text-sm lg:text-base' />
        이전 문서
      </button>
      <button
        type='text'
        className='btn-whitePrimary px-3 py-2 tracking-tight font-bold text-sm lg:text-base'
        onClick={() => {
          setKeyText([''])
          OpenLawFile(getNextFile(fileName))
        }}
      >
        다음 문서
        <FontAwesomeIcon icon={faChevronRight} className='ml-2 text-sm lg:text-base' />
      </button>
    </div>
  )
}

export default ProjectContentHeader
